import { createReducer, on } from '@ngrx/store';
import {
  loadOrderDataAction,
  createReturnOrderAction,
  addItemToReturnOrderAction,
  removeItemFromReturnOrderAction,
  clearItemsFromReturnOrderAction,
  updateItemFromReturnOrderAction,
  updateDeliveryOptionInReturnOrder,
  addLabelToReturnOrder,
  removeLabelFromReturnOrder,
  fillReturnOrderAction,
  updateOrderAddressFromReturnOrderAction,
  addfreeTextToReturnOrder,
  removeTimeStampFromOrderDataAction,
  updateReturnToAddressFromReturnOrderAction,
} from '../actions/order.actions';

export const initialOrderState = {
};

export const initialReturnOrderState :any ={
  items: [],
};


const _orderReducer = createReducer(
  initialOrderState,
  on(loadOrderDataAction, (state, { payload }) => {
    return {
      ...state,
      ...payload,
    };
  }),
  on(removeTimeStampFromOrderDataAction, (state, { payload }) => {
    return {
      ...state,
      ...payload,
    };
  })
);

export function orderReducer(state, action) {
  return _orderReducer(state, action);
}


const _returnOrderReducer = createReducer(
  initialReturnOrderState,
  on(createReturnOrderAction, (state, { payload }) => {
    return {
      ...state,
      ...payload,
    };
  }),

  on(fillReturnOrderAction, (state, { payload }) => {
    return {
      ...state,
      ...payload.order,
    };
  }),

  on(addItemToReturnOrderAction, (state, { payload }) => {
    const items = [...state.items];
    items.push({ ...payload.item });

    if (!state.orderNumber && payload.order) {
      return {
        ...state,
        ...payload.order,
        items: [...items],
      };
    }

    return {
      ...state,
      items: [...items],
    };
  }),

  on(removeItemFromReturnOrderAction, (state, { payload }) => {
    const items = state.items.filter((i) => i.itemNumber !== payload.item.itemNumber);
    return {
      ...state,
      items: [...items],
    };
  }),

  on(clearItemsFromReturnOrderAction, (state) => {
    const items = [];
    return {
      ...state,
      items: [...items],
    };
  }),

  on(updateItemFromReturnOrderAction, (state, { payload }) => {
    const items = [...state.items];
    const index = items.findIndex((i) => i.itemNumber === payload.itemNumber);
    if (index !== -1) {
      items[index] = {
        ...items[index],
        ...payload.item,
      };

      const itm = items[index];
      if (itm.reasonForReturn && itm.reasonForReturn !== '' && itm.returnQuantity && itm.returnQuantity > 0) {
        items[index].isValid = true;
      }
    }

    return {
      ...state,
      items: [...items],
    };
  }),

  on(updateOrderAddressFromReturnOrderAction, (state, { payload }) => {
    let orderAddress = state.orderAddress || {};
    orderAddress = { ...orderAddress, ...payload };
    return {
      ...state,
      orderAddress: { ...orderAddress },
    };
  }),

  on(updateReturnToAddressFromReturnOrderAction, (state, { payload }) => {
    let returnToAddress = state.returnToAddress || {};
    returnToAddress = { ...returnToAddress, ...payload };
    return {
      ...state,
      returnToAddress: { ...returnToAddress },
    };
  }),

  on(updateDeliveryOptionInReturnOrder, (state, { payload }) => {
    let deliveryOption = state.deliveryOption || {};
    deliveryOption = { ...deliveryOption, ...payload };
    return {
      ...state,
      deliveryOption: { ...deliveryOption },
    };
  }),

  on(addLabelToReturnOrder, (state, { payload }) => {
    return {
      ...state,
      label: { ...payload },
    };
  }),

  on(addfreeTextToReturnOrder, (state, { payload }) => {
    return {
      ...state,
      ...payload,
    };
  }),

  on(removeLabelFromReturnOrder, (state) => {
    return {
      ...state,
      label: null,
    };
  })
);

export function returnOrderReducer(state, action) {
  return _returnOrderReducer(state, action);
}
